import styled from 'styled-components';

export const UpgradePagesTilesWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const UpgradePagesTilesRoot = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  width: 100%;
`;

export const UpgradePagesTile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
